import { NgClass, NgStyle } from '@angular/common';
import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';

@Component({
  selector: 'app-early-pay-calculator-days-selector',
  templateUrl: './early-pay-calculator-days-selector.component.html',
  styleUrls: ['./early-pay-calculator-days-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatRippleModule, NgClass, NgStyle],
})
export class EarlyPayCalculatorDaysSelectorComponent {
  daysAmount = 30;
  @Output() changeDays: EventEmitter<number> = new EventEmitter<number>();

  updateDaysAmount(daysAmount: number): void {
    if (this.daysAmount !== daysAmount) {
      this.daysAmount = daysAmount;
      this.changeDays.emit(daysAmount);
    }
  }

  calculateProgressWidth(isFilled: boolean, days: number): number {
    const maxDaysAmount = 120;
    return isFilled ? (days / maxDaysAmount) * 100 : (1 - days / maxDaysAmount) * 100;
  }
}
